import * as React from 'react';
import classNames from 'classnames';
import { ArticleParagraph1, ArticleParagraph2, IconButton, IconChevronRight16, IconUser16, useDeviceType } from '@cian/ui-kit';
import * as styles from './Account.css';
import { Button } from '../Button';
import { prepareAccountInfo } from '../../utils/prepareAccountInfo';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Account = function Account(_ref) {
  var loading = _ref.loading,
    disabled = _ref.disabled,
    email = _ref.email,
    phone = _ref.phone,
    avatarUrl = _ref.avatarUrl,
    agencyName = _ref.agencyName,
    lastActivityDate = _ref.lastActivityDate,
    publishedAnnouncementsCount = _ref.publishedAnnouncementsCount,
    onClick = _ref.onClick;
  var deviceType = useDeviceType();
  var handleClick = React.useCallback(function () {
    return onClick();
  }, [onClick]);
  return /*#__PURE__*/_jsxs(Button, {
    disabled: loading || disabled,
    loading: loading,
    deviceType: deviceType,
    onClick: handleClick,
    children: [/*#__PURE__*/_jsx("span", {
      className: styles['account-icon'],
      "data-name": "avatar",
      children: !disabled && avatarUrl ? /*#__PURE__*/_jsx("img", {
        className: styles['avatar'],
        decoding: "async",
        loading: "lazy",
        src: avatarUrl
      }) : /*#__PURE__*/_jsx(IconUser16, {})
    }), /*#__PURE__*/_jsxs("span", {
      className: classNames(styles['account-content'], styles["account-content--".concat(deviceType)]),
      children: [email && /*#__PURE__*/_jsx("span", {
        className: styles['account-content--email'],
        children: /*#__PURE__*/_jsx(ArticleParagraph1, {
          color: disabled ? 'black_60' : 'black_100',
          "data-name": "email",
          children: email
        })
      }), phone && /*#__PURE__*/_jsx(ArticleParagraph1, {
        color: disabled ? 'black_60' : 'black_100',
        "data-name": "phone",
        children: phone
      }), agencyName && /*#__PURE__*/_jsx(ArticleParagraph2, {
        color: "black_60",
        "data-name": "agencyName",
        children: agencyName
      }), (publishedAnnouncementsCount || lastActivityDate) && /*#__PURE__*/_jsx(ArticleParagraph2, {
        color: "black_60",
        "data-name": "AccountInfo",
        children: prepareAccountInfo({
          publishedAnnouncementsCount: publishedAnnouncementsCount,
          lastActivityDate: lastActivityDate
        })
      })]
    }), !disabled && /*#__PURE__*/_jsx("span", {
      "data-name": "ChevronBtn",
      className: styles['chevron-button'],
      children: /*#__PURE__*/_jsx(IconButton, {
        icon: /*#__PURE__*/_jsx(IconChevronRight16, {
          color: "primary_100"
        })
      })
    })]
  });
};
Account.displayName = 'Account';